import { useMemo } from 'react';

import { PureSwitch } from '@/components/form/Switch'
import { NameAndCreateDateFormatter } from '@/components/Grid/components/Table/formatters';
import column, { defaultColumn, defaultActionsColumn, deleteAction, editAction, defaultColumnId } from '@Components/Grid/utils/column';

import OrganizationLinkFormatter from './OrganizationLinkFormatter';
import ToggleFormatter from './ToggleFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('name', 'Name', info => <NameAndCreateDateFormatter info={info} />),
    defaultColumn('domain', 'Domain', undefined, { enableTruncate: true }),
    defaultColumn('viewdir', 'Viewdir'),
    column.accessor('meta.preflight', {
      header: 'Midpath Pre-flight',
      cell: info => <PureSwitch value={!!info.getValue()} disabled />,
      defaultVisible: false,
      enableSorting: false,
      enableColumnResize: false,
    }),
    column.accessor('meta.registrationDelay', {
      header: 'Registration Delay in minutes',
      defaultVisible: false,
      enableSorting: false,
    }),
    column.accessor('organizationId', {
      header: 'Organization',
      cell: info => <OrganizationLinkFormatter info={info} />,
    }),
    defaultColumn('active', 'Active', info => <ToggleFormatter info={info} />, { initialSize: 'w-18', enableColumnResize: false, enableSorting: false }),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
